// (C) Copyright 2020 MediaWink, LLC

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  TextField,
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import AppMenu from './AppMenu';
import Breadcrumbs from '../components/Breadcrumbs';
import ViewSettings from '../components/ViewSettings';
import {
  triggerPlayAppSaga,
  triggerSetPublicBreadcrumbsSaga,
} from '../actions/items';
import {
  selectBreadcrumbs,
  selectHtml,
  selectScreenListItemsArray,
  selectScreenListId,
} from '../selectors';

function PlayApp({
  debug,
}) {
  // console.log('playApp');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [input, setInput] = useState('0.00');
  const html = useSelector(selectHtml);
  const screenItems = useSelector(selectScreenListItemsArray);
  const screenListId = useSelector(selectScreenListId);
  const breadcrumbs = useSelector(selectBreadcrumbs);
  const startApp = (data) => dispatch(
    triggerPlayAppSaga(data, navigate),
  );
  const setPublicBreadcrumbsSaga = (crumbs) => dispatch(
    triggerSetPublicBreadcrumbsSaga({ breadcrumbs: crumbs }),
  );
  const buttonHandler = (val) => {
    // console.log('buttonHanlder() val -- TBD:', val);

    /*
    console.log('textField', textField);
    setTarget(val);
    vars = setAndSaveVariable('DEPOSIT_AMOUNT', textField.DEPOSIT_AMOUNT || 0);
    vars = setAndSaveVariable('PURCHASE_AMOUNT', textField.PURCHASE_AMOUNT || 0);
    setTick(prev => prev + 1);
    // eslint-disable-next-line arrow-body-style
    textField = { ...textField, 'PURCHASE_AMOUNT': '', 'DEPOSIT_AMOUNT': '' };
  */

    // FIXes Button press, may break BudgetHub (SPA)
    const s = screenListId;
    // console.log({ screenItems });
    // console.log({ s });
    for (let n = 0; n < screenItems.length; n += 1) {
      const i = screenItems[n];
      if (i.Name.value === val) {
        const newCrumbs = [...breadcrumbs.slice(0, -2), s, i.id];
        console.log({ newCrumbs });
        setPublicBreadcrumbsSaga(newCrumbs);
        console.log({ return: true });
        return;
      }
    }
  };

  const tf = (
    <TextField
      id='value'
      key='tf'
      label='title'
      defaultValue='list'
      initialValue={input}
      value={input}
    />
  );
  useEffect(() => {
    // console.log('playApp useEffect()');
    if (window.location.pathname === '/app') {
      console.log({
        'startApp': true, dispatch, input, setInput,
      });
      startApp({
        dispatch, inputObj: { input }, setInput, tfObj: { tf },
      });
    } else {
      // console.log('NOT starting app.  Location:', window.location.path);
    }
    // console.log({ html });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [breadcrumbs]);
  // console.log({ html });
  // console.log('playApp return:');
  // console.log({ tf });
  // console.log({ html });
  return (
    <Box key='PlayApp'>
      {debug && (
        <Box key='debugPlayApp'>
          <ViewSettings className='tour-view-settings' />
        </Box>
      )}
      {debug && (
        <Box
          key='PlayAppBreadCrumbs'
          display='flex'
          flexDirection='row'
          className='tour-breadcrumbs'
        >
          <Breadcrumbs debug={debug} />
        </Box>
      )}
      <AppMenu goTo={buttonHandler} />
      {html?.props ? html : 'Loading...'}
    </Box>
  );
}

PlayApp.propTypes = {
  debug: PropTypes.bool.isRequired,
};

export default PlayApp;
